/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "business": {
            "nested": {
              "categories": {
                "nested": {
                  "BusinessCategory": {
                    "values": {
                      "BUSINESS_CATEGORY_UNKNOWN": 0,
                      "BUSINESS_CATEGORY_BEAUTY_AND_PERSONAL_CARE": 1,
                      "BUSINESS_CATEGORY_BEAUTY_MEDICAL_AND_FITNESS": 2,
                      "BUSINESS_CATEGORY_CASUAL_USE": 3,
                      "BUSINESS_CATEGORY_CHARITIES_AND_GROUPS": 4,
                      "BUSINESS_CATEGORY_CHARITIES_EDUCATION_AND_MEMBERSHIP": 5,
                      "BUSINESS_CATEGORY_EDUCATION": 6,
                      "BUSINESS_CATEGORY_FOOD_AND_DRINK": 7,
                      "BUSINESS_CATEGORY_HEALTH_CARE_AND_FITNESS": 8,
                      "BUSINESS_CATEGORY_HOME_AND_REPAIR": 9,
                      "BUSINESS_CATEGORY_LEISURE_AND_ENTERTAINMENT": 10,
                      "BUSINESS_CATEGORY_MANUFACTURING_AND_OTHERS": 11,
                      "BUSINESS_CATEGORY_PROFESSIONAL_SERVICES": 12,
                      "BUSINESS_CATEGORY_RETAIL": 13,
                      "BUSINESS_CATEGORY_SERVICE": 14,
                      "BUSINESS_CATEGORY_TRANSPORTATION": 15,
                      "BUSINESS_CATEGORY_WHOLESALE": 16,
                      "BUSINESS_CATEGORY_FITNESS": 17,
                      "BUSINESS_CATEGORY_HEALTH_CARE": 18,
                      "BUSINESS_CATEGORY_PET_CARE": 19,
                      "BUSINESS_CATEGORY_BEAUTY": 20,
                      "BUSINESS_CATEGORY_HEALTH": 21
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.business?.nested?.categories?.nested?.BusinessCategory) {
  $root.addJSON(jsonData);
}

/**
 * This is the canonical list of business categories a merchant can select.
 * Each category can be associated with a sub-category.
 * The mapping between a category and subcategory is defined by configs in the onboard service:
 * https://git.sqcorp.co/projects/SQ/repos/onboard/browse/config/business_categories
 *
 * SOURCE BusinessCategory @ squareup/onboard/business/categories.proto at 8:1
 */
export const BusinessCategory = $root.lookupEnum('squareup.onboard.business.categories.BusinessCategory').values;